/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { RouteObject } from 'react-router'
import InvoiceFormPage from './InvoiceFormPage'
import InvoiceListPage from './InvoiceListPage'

export const invoiceRoutes: RouteObject[] = [
  {
    index: true,
    element: <InvoiceListPage />
  },
  {
    path: 'create',
    element: <InvoiceFormPage />
  },
  {
    path: ':id/*',
    children: [
      {
        path: 'edit',
        element: <InvoiceFormPage />
      }
    ]
  }
]
